// extracted by mini-css-extract-plugin
export default {"btnBlock":"styles_btnBlock__eB2fG","langSwitchBtn":"styles_langSwitchBtn__z0i0f","active":"styles_active__wtjIA"};